export const Back = `
<path fill-rule="evenodd" clip-rule="evenodd" d="M218.51 448H960C995.346 448 1024 476.654 1024 512C1024 547.346 995.346 576 960 576H218.51L557.255 914.745C582.248 939.739 582.248 980.261 557.255 1005.25C532.261 1030.25 491.739 1030.25 466.745 1005.25L18.7785 557.288C18.6794 557.189 18.5806 557.09 18.4821 556.99C12.478 550.917 7.9367 543.942 4.85834 536.503C1.72785 528.956 0 520.68 0 512C0 494.427 7.08212 478.509 18.5478 466.943C18.6215 466.869 18.6954 466.795 18.7694 466.721L466.745 18.7452C491.739 -6.24839 532.261 -6.24839 557.255 18.7452C582.248 43.7387 582.248 84.2613 557.255 109.255L218.51 448Z"/>
`;






// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/icons/back.js